module.exports = __webpack_public_path__ + "img/508.2bd4faba.jpg";